var map = {
	"./gemeente.png": 4053,
	"./gemeenten.png": 8943,
	"./huisarts.png": 9600,
	"./jgz.png": 402,
	"./kraamzorg.png": 6601,
	"./lactatiekunde.png": 5259,
	"./ouders.png": 2443,
	"./verloskunde.png": 2937,
	"./ziekenhuis.png": 9972
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1411;